import authService from "@/services/authService";
import axios from 'axios';
export default new class TrainingService {
    async updateTrainingsByDate() {
        const token = await authService.currentUser.getIdToken();
        const instance = axios.create({
            baseURL: process.env.VUE_APP_FIREBASE_FUNCTIONS_URL,
            headers: { 'Authorization': `Bearer ${token}` }
        });
        await instance.post('update-trainings');
    }
};
